import { html, nothing, css } from "lit";
import { ifDefined } from "lit-html/directives/if-defined.js";
import { SignalWatcher } from "@lit-labs/preact-signals";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { isMobile, mediaQueries } from "../../../responsive/index.js";
import { rif } from "../../../helpers/renderIf.js";
import { testingAttr } from "../../../directives/testingAttr.js";
import { TestingAttrs } from "./sidebar.selectors.js";
import "../Button/index.js";
import "../../atom/Text/index.js";
import "../../atom/ModalBase/index.js";
import "../IconButton/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfSidebar = class extends SignalWatcher(BaseComponent) {
  constructor() {
    super(...arguments);
    this.dsf_focus_selector = "input";
  }
  onClose() {
    this.emit("close");
  }
  get header() {
    const title = rif(
      this.dsf_title,
      html`<dsf-text dsf_level="s-semibold">${this.dsf_title}</dsf-text>`
    );
    return html`
      <div
        slot="header"
        class="flex flex-row items-center border-b border-b-neutral-100 p-16 mobile:py-12"
      >
        <div class="flex flex-auto gap-10">
          ${title}
          <slot name="header-content"></slot>
        </div>
        <slot name="header-actions" class="self-end"></slot>
        <dsf-icon-button dsf_title="X" dsf_icon="X" @click=${this.onClose}></dsf-icon-button>
      </div>
    `;
  }
  get footer() {
    if (!this.dsf_cancel_text && !this.dsf_confirm_text) {
      return nothing;
    }
    const cancelButton = rif(
      this.dsf_cancel_text,
      html` <dsf-button
        @click=${() => this.emit("cancel")}
        dsf_level="secondary"
        dsf_size=${isMobile() ? "small" : "medium"}
        ${testingAttr(TestingAttrs.cancelButton)}
      >
        ${this.dsf_cancel_text}
      </dsf-button>`
    );
    const confirmButton = rif(
      this.dsf_confirm_text,
      html` <dsf-button
        @click=${() => this.emit("confirm")}
        dsf_size=${isMobile() ? "small" : "medium"}
        ${testingAttr(TestingAttrs.confirmButton)}
      >
        ${this.dsf_confirm_text}
      </dsf-button>`
    );
    return html`
      <div
        slot="footer"
        class="flex justify-end gap-10 border-t border-t-neutral-100 p-16 mobile:py-12"
      >
        ${cancelButton} ${confirmButton}
      </div>
    `;
  }
  render() {
    if (!this.dsf_open) {
      return nothing;
    }
    return html`<dsf-modal-base
      exportparts="overlay, modal"
      dsf_focus_selector=${ifDefined(this.dsf_focus_selector)}
    >
      ${this.header}
      <div slot="content" part="content" class="flex-auto overflow-auto p-16">
        <slot></slot>
      </div>
      ${this.footer}
    </dsf-modal-base>`;
  }
};
DsfSidebar.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
DsfSidebar.styles = [
  ...BaseComponent.styles,
  css`
      dsf-modal-base::part(overlay) {
        justify-content: flex-end;
      }
      dsf-modal-base::part(modal) {
        max-width: 50vw;
        height: 100vh;
        border-radius: 0px;
      }
    `,
  mediaQueries.mobile.down(css`
      dsf-modal-base::part(modal) {
        max-width: 100vw;
        width: 100vw;
      }
    `)
];
__decorateClass([
  prop({ type: String })
], DsfSidebar.prototype, "dsf_title", 2);
__decorateClass([
  prop({ type: String })
], DsfSidebar.prototype, "dsf_cancel_text", 2);
__decorateClass([
  prop({ type: String })
], DsfSidebar.prototype, "dsf_confirm_text", 2);
__decorateClass([
  prop({ type: String })
], DsfSidebar.prototype, "dsf_focus_selector", 2);
__decorateClass([
  prop({ type: Boolean })
], DsfSidebar.prototype, "dsf_open", 2);
DsfSidebar = __decorateClass([
  defineElement("dsf-sidebar")
], DsfSidebar);
export {
  DsfSidebar
};
